<template>
    <div class="btn-go-to-top" v-show="isBottom" @click="clickGoToTop()">
        Go to Top
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";

export default {
    name: "BackToTop",
    props: {
        scrollObserv: Object,
    },
    data: function() {
        return {
            isBottom: false,
        };
    },
    created: function() {
        this.scrollObserv.subscribe((isBottom) => {
            this.onBottomPage(isBottom);
        });
    },
    methods: {
        onBottomPage: function(isBottom) {
            this.isBottom = isBottom;
        },
        clickGoToTop: function() {
            Util.scrollTop(true);
        },
    },
}
</script>
<style lang="scss" scoped>
    .btn-go-to-top {
        position: fixed;
        bottom: 30px;
        right: 30px;
        width: 80px;
        background: #000;
        color: #ffffff;
        text-align: center;
        padding: 5px;
    }
</style>
